<template>
<div>
    <div class="row">
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">고시원 이름 <span class="text-danger">*</span></label>
                <input class="form-control" type="text" id="name" placeholder="고시원 이름을 입력해주세요." v-model="kosiwon.name" @blur="onBlur($event)" />
                <label class="font-13 text-muted fw-light mt-1">e.g "휴식"</label>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">지점명</label>
                <input class="form-control" type="text" id="branch" placeholder="지점명을 입력해주세요." v-model="kosiwon.branch" />
                <label class="font-13 text-muted fw-light mt-1">e.g "노원 1호점"</label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">원장님 성함 <span class="text-danger">*</span></label>
                <input class="form-control" type="text" id="owner_name" placeholder="원장님 성함을 입력해주세요." v-model="kosiwon.owner_name" @blur="onBlur($event)" />
            </div>
        </div>
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">사업자 번호 <span class="text-danger">*</span></label>
                <input class="form-control" type="text" id="company_registration_number" placeholder="사업자 번호를 입력해주세요." v-model="kosiwon.company_registration_number" @blur="onBlur($event)" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">주소 <span class="text-danger">*</span></label>
                <input class="form-control" type="text" id="address_brief" placeholder="클릭하여 주소를 검색해주세요." v-model="kosiwon.address_brief" @click="openSearchAddress()" readonly @blur="onBlur($event)" />
            </div>
        </div>
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">상세 주소 <span class="text-danger">*</span></label>
                <input class="form-control" type="text" id="address_detail" placeholder="상세 주소를 입력해주세요." v-model="kosiwon.address_detail" @blur="onBlur($event)" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class="mb-4">
                <div class="row">
                    <div class="col-6">
                        <label class="form-label">층 수 <span class="text-danger">*</span></label>
                        <input class="form-control" type="text" id="floor" placeholder="사용중인 고시원 층" v-model="kosiwon.floor" @blur="onBlur($event)" />
                        <label class="font-13 text-muted fw-light mt-1">e.g "3층" 또는 "3~5층"</label>
                    </div>
                    <div class="col-6">
                        <label class="form-label">&nbsp;</label>
                        <input class="form-control" type="text" id="building_floor" placeholder="건물 전체 층" v-model="kosiwon.building_floor" @blur="onBlur($event)" />
                        <label class="font-13 text-muted fw-light mt-1">e.g "5층"</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">홈페이지 URL</label>
                <input class="form-control" type="text" placeholder="홈페이지 URL을 입력해주세요." v-model="kosiwon.url" />
                <label class="font-13 text-muted fw-light mt-1">e.g "https://kosirock.com"</label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class="mb-4">
                <div class="row">
                    <div class="col-6">
                        <label class="form-label">고시원 대표 번호 <span class="text-danger">*</span></label>
                        <input class="form-control" type="tel" id="phone_no" placeholder="고시원 대표 번호" v-model="kosiwon.phone_no" @blur="onBlur($event)" />
                        <label class="font-13 text-muted fw-light mt-1">고시원 대표 번호가 존재하지 않으면 원장님 휴대폰 번호를 입력해주세요.</label>
                    </div>
                    <div class="col-6">
                        <label class="form-label">&nbsp;</label>
                        <input class="form-control" type="tel" placeholder="실제 노출 번호" v-model="kosiwon.virtual_no" style="background-color: var(--ct-gray-100);" readonly />
                        <label class="font-13 text-muted fw-light mt-1">실제 노출 번호는 고시원 등록 후, 자동으로 매핑됩니다.</label>
                    </div>
                </div>
            </div>
            <div class="mb-4">
                <label class="form-label">원장님 휴대폰 번호 <span class="text-danger">*</span></label>
                <input class="form-control" type="tel" id="cellphone_no" placeholder="원장님 휴대폰 번호를 입력해주세요." v-model="kosiwon.cellphone_no" @blur="onBlur($event)" />
            </div>
            <div class="mb-4">
                <label class="form-label">고시원 최소/최대 가격 (단위 : 만원) <span class="text-danger">*</span></label>
                <input type="text" id="price" data-plugin="range-slider" data-min="0" data-max="120" data-from="30" data-to="60" data-type="double" data-grid="true" data-postfix=" 만원" />
            </div>
            <div class="mb-4">
                <label class="form-label">보증금 (단위 : 만원 / 없을 시, 0원) <span class="text-danger">*</span></label>
                <input type="text" id="deposit" data-plugin="range-slider" data-min="0" data-max="100" data-from="10" data-grid="true" data-postfix=" 만원" />
            </div>
        </div>
        <div class="col-lg-6">
            <div class="mb-4">
                <label class="form-label">고시원 한 줄 소개 <span class="text-danger">*</span></label>
                <input class="form-control" type="text" id="intro" placeholder="고시원 한 줄 소개를 자유롭게 입력해주세요." v-model="kosiwon.intro" @blur="onBlur($event)" />
                <label class="font-13 text-muted fw-light mt-1">e.g "24 년 6월 오픈! 논현역 도보 5분 프리미엄 레지던스 휴식 논현점 "</label>
            </div>
            <div class="mb-4">
                <label class="form-label">고시원 상세 설명 <span class="text-danger">*</span></label>
                <textarea class="form-control" id="description" rows="13" v-model="kosiwon.description" :placeholder="description_example" @blur="onBlur($event)"></textarea>
            </div>
        </div>
    </div>

    <ul class="list-inline wizard mb-0">
        <li class="list-inline-item float-end">
            <a href="javascript:void(0);" class="btn btn-info button-next me-1 d-none d-sm-inline">옵션 정보 입력하기 <i class="mdi mdi-arrow-right ms-1"></i></a>
            <button type="button" class="btn btn-info" @click="$emit('open-confirm-modal')">{{ btnText }}</button>
        </li>
    </ul>
</div>
</template>

<script>
export default {
    props: [
        "kosiwon",
        "btnText"
    ],
    data() {
        return {
            description_example: "<예시>\n" +
                "프리미엄 레지던스 휴식은? \n" +
                "- 고시락이 제공하는 1인 주거공간 프리미엄 레지던스 휴식입니다. \n\n" +
                "개인 시설 \n" +
                "- 각 방마다 유선방송 무료 시청가능한 TV 설치 \n" +
                "- 침대, 책상, 책꽂이, 옷장, 미니 냉장고 풀옵션\n" +
                "- 초고속 인터넷 및 Wi-Fi 설치\n" +
                "- 욕실/화장실 구비되어있는 원룸\n\n" +
                "공용 시설\n" +
                "- 주방 : 김치냉장고, 정수기, 전자레인지\n" +
                "- 세탁실 및 다림질실\n" +
                "- 소화기 및 화재 감지 시스템\n" +
                "- 밥, 김치, 라면, 계란, 커피, 녹차 무료제공",
        }
    },
    methods: {
        onBlur(event) {
            this.$emit("validate-field", event.target.id);
        },
        openSearchAddress() {
            new daum.Postcode({
                oncomplete: (data) => {
                    // 주소-좌표 변환 객체를 생성합니다
                    const geocoder = new daum.maps.services.Geocoder(); // 주소 -> 좌표 변환 객체 생성

                    geocoder.addressSearch(data.address, (result, status) => { // 주소로 좌표를 검색.
                        if (result.length > 0 && status === daum.maps.services.Status.OK) { // 정상적으로 검색이 완료되었다면.
                            this.kosiwon.lat = result[0].y;
                            this.kosiwon.lng = result[0].x;
                            this.kosiwon.address_brief = data.address;
                        } else {
                            alert("해당 주소는 Daum 지도에 표시되지 않아 위도/경도 값을 가져올 수 없습니다.\n다른 주소로 시도해주세요.");
                        }
                    });
                }
            }).open();
        }
    }
}
</script>

<style>
[data-bs-theme=dark] {
    --ct-gray-100: #37404a;
}
</style>
